import { ReplenishmentTemplateCategoryListPage } from '@/features/replenishment-template-category/pages/ReplenishmentTemplateCategoryListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/replenishment-template-category/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment_template_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentTemplateCategoryListPage,
})
